import { render, staticRenderFns } from "./BrandVote.vue?vue&type=template&id=4a0ce9de&scoped=true"
import script from "./BrandVote.vue?vue&type=script&lang=js"
export * from "./BrandVote.vue?vue&type=script&lang=js"
import style0 from "./BrandVote.vue?vue&type=style&index=0&id=4a0ce9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ce9de",
  null
  
)

export default component.exports